module.exports = {
      id: "comm-automobile-usage",
      viewBox: "0 0 231.941 38.7",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-automobile",
      toString: function () {
        return this.url;
      }
    }